import React, {Component} from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";

import list1 from "../../../Assets/img/brand_awarenes.svg";
import list2 from "../../../Assets/img/reach_mass.svg";
import list3 from "../../../Assets/img/become_featured.svg";
import list4 from "../../../Assets/img/get_visible.svg";
import app_installs from "../../../Assets/img/App-Installs.jpg";
import awareness from "../../../Assets/img/Awareness.jpg";
import elite from "../../../Assets/img/Elite.jpg";
import familiarity from "../../../Assets/img/Familiarity.jpg";
import prizes from "../../../Assets/img/Prizes.jpg";
import Scrollchor from 'react-scrollchor';
import sponsor from "../../../Assets/img/become_sponsor.svg";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
// import { authenticate } from "../../Components/Utils";
import { ContactForm, sponsor_section } from "./contact_partials";

class BecomeSponsor extends Component {

  // componentDidMount(){
  //   if(authenticate()) {
  //     this.props.history.push('/pre-start');
  //   }
  // }

  render() {
  return (
    <div className="become_sponsor innerBody">
      <Header />
      <div className="container-fluid">
        <div className="row mt-4 mb-4">
          <div className="col-xl-6 col-lg-5 col-md-12 col-12 mt-5">
            <div className="benifits">
              <h3 className="mb-5">SPONSOR THE WORLD'S FAVORITE PUZZLING EVENT</h3>
              <p>Puzzled is a unique event which is played enthusiastically by Puzzlers all over the world. By sponsoring us, you make your brand familiar to some of the smartest people on the internet and we will take care of spinning up puzzles to match your branding needs.</p>
              <br/>
              <Scrollchor to="#how_it_works" animate={{duration: 450}}>
                <button
                  type="button"
                  className="btn btn-yellow g-recaptcha">
                  SEE HOW IT WORKS
                </button>
              </Scrollchor>
            </div>
          </div>

          <div className="col-xl-6 col-lg-7 col-md-12 col-12 mt-4 mb-4 sponsor_bg">
            <ContactForm title="BECOME A SPONSOR" button_name="Become a sponsor"/>
            <img src={sponsor} alt=""/>
          </div>
        </div>
      </div>


      <div className="container mt-5 mb-4">

         <h3 className="text-center">REACH YOUR BRAND TO THE BRIGHTEST OF MINDS</h3>


          <div className="pt-3 pb-5">

            <div className="row text-center skills_required">
              <div className="col-md-3 col-6 col-lg-3 mb-4 mb-lg-0">
                <img src={list1} alt="" /> <br/>
                <span> Brand <br/> Awareness </span> 
              </div>
              <div className="col-md-3 col-6 col-lg-3 mb-4 mb-lg-0">
                <img src={list2} alt="" /> <br/>
                <span> Reach Intellectual <br/> Audience </span>
              </div>
              <div className="col-md-3 col-6 col-lg-3 mb-4 mb-lg-0">
                <img src={list3} alt="" /> <br/>
                <span> Penetrate the <br/> Elite Segment</span>
              </div>
              <div className="col-md-3 col-6 col-lg-3 mb-4 mb-lg-0">
                <img src={list4} alt="" /> <br/>
                <span> Get Viral  <br/> Marketing </span>
              </div>
            </div>
          </div>


           <h3 className="mt-5 mb-5 text-center" id="how_it_works">HOW WE PROMOTE YOUR BRAND</h3>  
           


           <Tabs>
     <TabList>
       <Tab>App Installs</Tab>
      <Tab>Prizes</Tab>
      <Tab>Awareness</Tab>
      <Tab>Familiarity</Tab>
      <Tab>Elite Audience</Tab>
     </TabList>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={app_installs} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>App Installs and Promoting Traffic</h4> <br/>

            <p>In every edition of Puzzled, there will be specific levels which involve installing a sponsor's app/solution.</p>
            <p>A typical example is a puzzle that involves installing your app and signing up for an account. We will lead the puzzlers to then search a product or a feature within your app. This will let your apps get better visibility and increase your installs.</p>  
        </div>

      </div>
      </TabPanel>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={prizes} alt=""/></div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Prize Sponsors</h4> <br/>

            <p>The winners of Puzzled are entitled to receive cool prizes from our sponsors.</p>
            <p>Imagine getting your product across to some of the brightest minds in the world, who have the worthiness to spread the product further within their elite circle.</p>  
        </div>

       </div>
      </TabPanel>

      <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={awareness} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Provide Intelligent Brand Awareness and Visibility</h4> <br/>

            <p>Each edition of puzzled has certain key sponsorship slots, which provide brand visibility on all Puzzled levels.</p>
            <p>Strategically positioned logo visibility on the edition landing page, as well as individual level pages makes the puzzlers visit the sponsor page frequently, especially considering the fact that in certain levels, puzzlers spend hours together solving them.</p>  
        </div>

      </div>
       </TabPanel>

       <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={familiarity} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Brand Usage</h4> <br/>

            <p>Puzzlers will be made to use sponsor's brand to solve levels</p>
            <p>In addition to making puzzlers install sponsor apps, certain levels promote users to learn more about the brand and also use it. A typical example is where one level could involve users learning about the history of a sponsor brand, and then use it to solve the level.</p>  
        </div>

      </div>
       </TabPanel>

       <TabPanel>
      <div className="row">

        <div className="col-md-4 col-12">
          <div className="tab_img"> <img src={elite} alt=""/> </div>
        </div>

        <div className="col-md-8 col-12 tab_cont">
            <h4>Take your brand to the Elite Segment</h4> <br/>

            <p>We have to admit, Puzzled is not for the weak-hearted. Puzzled is for the brightest minds out there.</p>
            <p>Sponsoring Puzzled takes your brand to the elite segment of the brightest minds in the world. Brand referrals and conversion values are quite high in this high net worth segment, which would boost your brand to a great extent.</p>  
        </div>

      </div>
       </TabPanel>
      </Tabs>
      {sponsor_section("SPONSORS OF PREVIOUS EDITIONS")}
    </div>
    <Footer />
    </div>
  );
}
}

export default BecomeSponsor;
